import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueApexCharts from 'vue3-apexcharts';
import './assets/css/uikit.css'
import './assets/css/style.css'
import './assets/css/custom.css'
// No need to import style-preset.css separately as its styles should be included in style.css

// Element Plus UI
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Import vue-files-preview
import VueFilesPreview from 'vue-files-preview'
import 'vue-files-preview/lib/style.css'

// Import our centralized API client so it's initialized before the app
import './services/apiClient'

// Import Firebase for notifications
import './plugins/firebase'

// Import global formatters plugin
import formattersPlugin from './plugins/formatters'

// Make router globally available for auth service
window.router = router

// Check authentication state before app starts
store.dispatch('auth/checkAuth')

// Create and mount the Vue application
const app = createApp(App)
app.use(router)
app.use(store)
app.use(i18n)
app.use(VueApexCharts);
app.use(VueFilesPreview) // Register VueFilesPreview plugin
app.use(ElementPlus)
app.use(formattersPlugin) // Register global formatters plugin
app.mount('#app')

// Initialize feather icons if available in window
if (window.feather) {
  window.feather.replace()
}

// Initialize feather icons when route changes
router.afterEach(() => {
  setTimeout(() => {
    if (window.feather) {
      window.feather.replace()
    }
  }, 100)
}) 